import { useState } from "react";
import { Tabs } from "../../../../components/common/Tabs";
import { useTheme } from "../../../../components/hooks/useTheme";
import { EnabledUsers } from "./EnabledUsers";
import { useNavigate } from "react-router-dom";
import { DisabledUsers } from "./DisabledUsers";
import { AllUsers } from "./AllUsers";
import colorConfigs from "../../../../configs/colorConfigs";

const tabs = [
  {
    label: "Enabled",
  },
  {
    label: "Disabled",
  },
  {
    label: "All",
  },
]

export const Users = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/admin/usermanagement/users/adduser")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">User</span>
            </button>

          </div>
        </div>
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <EnabledUsers />
            )
          }
          {
            activeIndex === 1 && (
              <DisabledUsers />
            )
          }

          {
            activeIndex === 2 && (
              <AllUsers />
            )
          }
        </div>
      </div>
    </div>
  )
}